<template>


  <div class="container">
    <div class="handle-box-search">


      <el-row class="head-search">

        <el-col :span="8">
          <span class="title">广告名称:</span>

          <!-- 搜索广告名 -->
          <el-input v-model="search_data.name" placeholder="请输入广告名称" class="handle-input mr10"
            @keyup.enter.native="searchAdvertLists"></el-input>
        </el-col>



      </el-row>


      <el-button type="primary" icon="el-icon-search" @click="searchAdvertLists">搜索</el-button>
      <el-button @click="addAdvert_isShow=!addAdvert_isShow">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" prop="driver_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item label="创建时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

              <el-form-item label="修改时间:">
                <span>{{ props.row.edit_time.Ymd }}</span>
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item label="修改详细时间:">
                <span>{{ props.row.edit_time.YmdHis }}</span>
              </el-form-item>

              <el-form-item label="唯一编码:">
                <span>{{ props.row.advert_code }}</span>
              </el-form-item>

              <el-form-item label="连接地址:">
                <span>{{ props.row.link }}</span>
              </el-form-item>

            </div>

            <el-form-item label="备注:">
              <span>{{ props.row.remarks }}</span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column label="列表图片">

        <template scope="scope">
          <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
            :src="scope.row.list_img.url"></el-image>

        </template>
      </el-table-column>


      <el-table-column prop="name" label="广告名称">
      </el-table-column>



      <el-table-column prop="time.Ymd" label="创建时间">
      </el-table-column>


      <el-table-column label="操作" width="150">
        <template slot-scope="scope">



          <el-dropdown split-button type="primary"
            @click="editAdvert_isShow = !editAdvert_isShow; editAdvert_drawer = scope.row.advert_code" trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="unBoundAll(scope.row.advert_code)">
                一键解绑
              </el-dropdown-item>

              <el-dropdown-item
                @click.native="advertContent_isShow = !advertContent_isShow; advertContent_body = scope.row.content;">
                广告内容
              </el-dropdown-item>



            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 批量删除按钮 -->
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>

    <!-- 分页组件 -->
    <div class="pagination">

      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>

    </div>


    <!-- 广告内容组件 -->
    <advertContent :data="advertContent_body" :isShow="advertContent_isShow"></advertContent>

    <!-- 添加广告组件 -->
    <addAdvert :isShow="addAdvert_isShow" @onSubmit="advertLists"></addAdvert>

    <!-- 编辑广告组件 -->
    <editAdvert :data="editAdvert_drawer" :isShow="editAdvert_isShow" @onSubmit="advertLists"></editAdvert>

  </div>


</template>

<script>
  import advertContent from './advertContent.vue';
  import addAdvert from './addAdvert.vue';
  import editAdvert from './editAdvert.vue';
  var _this;
  export default {
    components: {
      advertContent,
      addAdvert,
      editAdvert
    },
    data() {
      return {



        // 添加广告开关
        addAdvert_isShow: false,

        // 编辑广告开关
        editAdvert_isShow: false,

        //广告内容组件开关
        advertContent_isShow: false,

        // 广告内容
        advertContent_body: '',

        // 传入编辑组件的内容
        editAdvert_drawer: '',

        mode_price: '',

        // 批量删除
        delAdvertSubmit_data: {
          advert_code_array: []
        },
        delAdvertSubmit_rules: {
          advert_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          name: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;

      _this.advertLists();
    },

    methods: {



      searchAdvertLists() {

        _this.search_data.page = 1;
        _this.advertLists();

      },

      unBoundAll(code) {
        var code = JSON.stringify([code]);
        console.log(code);

        _this.$post(
            "/advert/unbindAdvertSubmit", {
              advert_code_array: code
            }
          )
          .then(res => {

            _this.advertLists();
            _this.$message.success(res.msg);

          }).catch((err) => {

          })


      },

      // 获取模式
      advertLists() {

        _this.$post(
            "/advert/advertLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;


            // 状态下拉的数据
            // _this.status_select = _this.tableData[0].status.select_array[0];

          }).catch((err) => {

          })

      },

      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;

        //初始化列表
        _this.advertLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].advert_code);

        }
        _this.delAdvertSubmit_data.advert_code_array = datalist;
      },

      // 批量删除
      deleteData() {

        if (_this.delAdvertSubmit_data.advert_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delAdvertSubmit_data.advert_code_array = JSON.stringify(_this.delAdvertSubmit_data.advert_code_array);

          console.log(_this.delAdvertSubmit_data);


          _this.$post(
              "/advert/deleteAdvertSubmit",
              _this.delAdvertSubmit_data,
              _this.delAdvertSubmit_rules
            )
            .then(res => {
              console.log(res);

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.advertLists();

              return;

            }).catch((err) => {
              console.log(err);



            })

            _this.delAdvertSubmit_data.advert_code_array = JSON.parse(_this.delAdvertSubmit_data.advert_code_array);

        }).catch(() => {

          _this.$message.info('已取消删除');

        });

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>